import type { LevelData } from '@/game/level';

export function replaceColor(data: LevelData, from: string, to: string): number {
  const f = from.toLowerCase();
  let count = 0;
  const maybe = (obj: Record<string, unknown>, key: string): void => {
    const v = obj[key];
    if (typeof v === 'string' && v.toLowerCase() === f) { obj[key] = to; count++; }
  };

  maybe(data.settings as unknown as Record<string, unknown>, 'baseColor');
  maybe(data.settings as unknown as Record<string, unknown>, 'accentColor');
  maybe(data.settings as unknown as Record<string, unknown>, 'backgroundColor');
  for (const seg of data.segments) {
    for (const o of seg.obstacles) {
      if (o.visual?.color && o.visual.color.toLowerCase() === f) {
        o.visual.color = to; count++;
      }
    }
  }
  for (const t of data.triggers) {
    const p = t.params as Record<string, unknown>;
    if (t.type === 'color') {
      maybe(p, 'baseColor');
      maybe(p, 'accentColor');
      maybe(p, 'backgroundColor');
    } else if (t.type === 'fog') {
      maybe(p, 'color');
    }
  }
  return count;
}
